export const HIDDEN_SECRET = '***';
export const TRACKS = [{ id: 1, name: 'Track 1' }, { id: 2, name: 'Track 2' }];
export const RECURRENCE_TYPES = [{ id: 0, name: 'RECUR_WEEKLY' }, { id: 1, name: 'DOES_NOT_REPEAT' }];
export const MAX_DAYS_GOING_FRONT = -90;
export const MAX_DAYS_GOING_BACK = 180;
export const DAYS_OF_THE_WEEK = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
